import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import {FAQ} from '../tutorial-panel/tutorial-panel.component';
import {Subject, Subscription} from 'rxjs';

@Component({
  selector: 'faq',
  template: require('./faq.component.html'),
  styles: [require('./faq.component.css')]
})
export class FaqComponent implements OnInit, OnDestroy {

  static closeAll = new Subject<void>();

  @Input()
  faq!: FAQ;

  get expanded()
  {
    return this._expanded;
  }

  set expanded(v)
  {
    this._expanded = v;
    if(v == false)
    {
      this.hide();
    }
  }

  _expanded = false;

  closeAllSubscription?: Subscription;

  constructor() 
  { 
    this.closeAllSubscription =  FaqComponent.closeAll.subscribe(() =>
    {
      this.expanded = false;
    });
  }

  ngOnInit() {
  }

  ngOnDestroy(): void 
  {
    this.closeAllSubscription && this.closeAllSubscription.unsubscribe();
  }

  onClick(event: MouseEvent)
  {
    if(!this.expanded) FaqComponent.closeAll.next();
    if(this.faq.expandAction)
    {
      this.faq.expandAction();
      return;
    }
    this.expanded = !this.expanded;
  }

  hide()
  {
    if(this.faq.hideAction)
      this.faq.hideAction();
  }

  onSeeMoreClick(event: MouseEvent)
  {
    if(this.faq.seeMoreAction)
    {
      this.faq.seeMoreAction();
    }
  }
}
